var exports = {
  "W": "xdde3148b--c88eb8--factoids",
};

module.exports = exports;
